var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownChevronIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.23967 8.70041C6.5432 8.41856 7.01775 8.43613 7.2996 8.73967L10 11.6478L12.7004 8.73967C12.9823 8.43613 13.4568 8.41856 13.7603 8.70041C14.0639 8.98226 14.0815 9.45681 13.7996 9.76034L10.5496 13.2603C10.4077 13.4132 10.2086 13.5 10 13.5C9.79145 13.5 9.59232 13.4132 9.45041 13.2603L6.20041 9.76034C5.91856 9.45681 5.93613 8.98226 6.23967 8.70041Z",
    fill: "#232222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownChevronIcon);
export default __webpack_public_path__ + "static/media/DownChevronIcon.d58a8b701a005e96057d6accc4b23051.svg";
export { ForwardRef as ReactComponent };